var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define(["require", "exports", "./number", "./analytics", "./renderCustomValance", "./context", "./contiunation", "./dialogs/login", "./util"], function (require, exports, number_1, analytics_1, renderCustomValance_1, context_1, contiunation_1, login_1, util_1) {
    "use strict";
    exports.__esModule = true;
    var favoriteSetName = 'favoriteSet';
    function updateFavoriteSet(favorites) {
        var set = favorites.reduce(function (cur, item) {
            var _a;
            return $.extend(cur, (_a = {}, _a[item.Href] = item, _a));
        }, {});
        window.sessionStorage.setItem(favoriteSetName, JSON.stringify(set));
    }
    exports.updateFavoriteSet = updateFavoriteSet;
    function resetFavoriteSet() {
        window.sessionStorage.removeItem(favoriteSetName);
    }
    exports.resetFavoriteSet = resetFavoriteSet;
    function ensureFavoriteSet() {
        var setJson = window.sessionStorage.getItem(favoriteSetName) || '{}';
        var set = JSON.parse(setJson);
        window.sessionStorage.setItem(favoriteSetName, setJson);
        return set;
    }
    exports.ensureFavoriteSet = ensureFavoriteSet;
    function refreshFavoriteSet() {
        var setJson = window.sessionStorage.getItem(favoriteSetName) || '{}';
        if (setJson === '{}') {
            return $.ajax({
                url: '/shoppingCart/getFavorites',
                type: 'GET',
                dataType: 'json'
            }).then(function (favorites) {
                var items = favorites.length ? favorites : [{
                        Href: 'nothere',
                        Id: -1,
                        Name: 'nothere',
                        CartImageUrl: null,
                        ProductVariantId: -1,
                        StyleIndex: -1
                    }];
                updateFavoriteSet(items);
                return true;
            });
        }
        else {
            return $.Deferred().resolve(false).promise();
        }
    }
    exports.refreshFavoriteSet = refreshFavoriteSet;
    var FavoriteAction = (function () {
        function FavoriteAction() {
            this.type = 'Login.AddFavorite';
        }
        return FavoriteAction;
    }());
    exports.FavoriteAction = FavoriteAction;
    function handleFavoriteAction(action) {
        switch (action.type) {
            case 'Login.OpenFavoriteToAdd':
                contiunation_1.registerContinuation(contiunation_1.ContinuationTrigger.LOGIN, {
                    type: 'Login.AddFavorite',
                    item: action.item
                });
                window.location.href = action.item.Href;
                break;
            case 'Login.AddFavorite':
                return toggleFavorite(action.item, true, 2000).then(function () { });
            default:
        }
        return $.Deferred().resolve().promise();
    }
    exports.handleFavoriteAction = handleFavoriteAction;
    contiunation_1.registerAction('Login.AddFavorite', handleFavoriteAction);
    contiunation_1.registerAction('Login.OpenFavoriteToAdd', handleFavoriteAction);
    function toggleFavorite(item, on, wait) {
        var req;
        if (on && !context_1["default"].isUserLoggedIn()) {
            analytics_1["default"]('favorite', 'prompt');
            contiunation_1.registerContinuation(contiunation_1.ContinuationTrigger.LOGIN, {
                type: 'Login.OpenFavoriteToAdd',
                item: item
            });
            login_1["default"]();
            return $.Deferred().resolve(false).promise();
        }
        if (on) {
            analytics_1["default"]('favorite', 'on');
            req = $.ajax({
                url: '/shoppingCart/addToFavorite',
                type: 'POST',
                data: item,
                dataType: 'json'
            });
        }
        else {
            analytics_1["default"]('favorite', 'off');
            var itemId = ensureFavoriteSet()[item.Href].Id;
            req = $.ajax({
                url: '/shoppingCart/removeFavorite',
                type: 'POST',
                data: __assign({}, item, { Id: itemId }),
                dataType: 'json'
            });
        }
        return req.then(function (favorites) {
            updateFavoriteSet(favorites);
            return on;
        })
            .then(function (on) {
            if (wait) {
                return util_1.delay(wait, on);
            }
            return on;
        })
            .then(function (on) {
            if (on) {
                return renderCustomValance_1.tryRenderCartImage();
            }
            return $.Deferred().resolve(null).promise();
        })
            .then(function (file) {
            if (file) {
                var itemId = ensureFavoriteSet()[item.Href].Id;
                var formData = new FormData();
                formData.append('imageFile', file);
                formData.append('id', "" + itemId);
                return $.ajax({
                    url: '/shoppingCart/SetFavoriteItemImage',
                    data: formData,
                    type: 'post',
                    contentType: false,
                    processData: false
                }).then(function () {
                    return on;
                });
            }
            return on;
        });
    }
    exports.toggleFavorite = toggleFavorite;
    function isFavorite(href) {
        return !!ensureFavoriteSet()[href];
    }
    exports.isFavorite = isFavorite;
    function favoritePath() {
        return "" + window.location.pathname + window.location.search;
    }
    exports.favoritePath = favoritePath;
    function checkFavoriteSet() {
        var $fav = $('#addToFavorite');
        if ($fav.length) {
            $fav.toggleClass('favorited', isFavorite(favoritePath()));
        }
    }
    exports.checkFavoriteSet = checkFavoriteSet;
    function getFavoriteName() {
        var name = window.document.title;
        if (name) {
            return name;
        }
        var style = ($('#custom_style_select .selected').text() || '').trim();
        var fabricId = $('.asset-picker[data-category_id="7"]').data('asset_id');
        var fabricName = ($("img.asset[data-asset_id=\"" + fabricId + "\"]").attr('title') || '').trim();
        if (style && fabricName) {
            return style + " - " + fabricName;
        }
        return 'Custom design';
    }
    exports.getFavoriteName = getFavoriteName;
    $(function () {
        var $fav = $('#addToFavorite');
        var href = favoritePath();
        $fav.toggleClass('showTip', !context_1["default"].isUserLoggedIn());
        $fav.click(function (evt) {
            var href = favoritePath();
            var productVariantId = parseInt($fav.data('variantid'));
            var styleIndex = productVariantId > 0 ? 0 : number_1.extractFieldAsDecimal($('input[data-attribute-name="styleIndex"]'));
            var name = getFavoriteName();
            var item = {
                Id: -1,
                Href: href,
                ProductVariantId: productVariantId,
                StyleIndex: styleIndex,
                Name: name,
                CartImageUrl: null
            };
            toggleFavorite(item, !isFavorite(href)).then(function (on) {
                $fav.toggleClass('favorited', on);
            });
        });
        refreshFavoriteSet().then(function () {
            $fav.toggleClass('favorited', isFavorite(href));
        });
    });
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/favorites.js
// module id = 52
// module chunks = 0